import * as React from 'react';
import { ProtectedPageWrapper } from '../../designSystem/layouts/pageWrappers/ProtectedPageWrapper';
import { LearningModuleList } from '../_components/learning/LearningModuleList';


export function LearningModuleListPage (): JSX.Element
{
    
    return (

        <ProtectedPageWrapper requiredPermissions={['ViewCustomFormAnswerList']} selectedMenuItemKey={'learning'}>
            <LearningModuleList />
        </ProtectedPageWrapper>
    );
}
